import { styled } from '@mui/material';

export const PageContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(4, 17.75, 7, 17.75),
  flex: 1
}));
